<main class="flex h-screen p-4 overflow-x-hidden public-page" role="main">
  <div class="m-auto mb-10 w-full max-w-[100%] md:max-w-[500px]">
    @if (resetCodeParam) {
      <app-reset-password-form />
    } @else {
      <app-forgot-password-form />
    }
  </div>
</main>
